import React, { ReactElement } from 'react';

export const Table: React.FC = ({ children }): ReactElement => (
  <div className="table-container">
    <table className="table is-striped is-fullwidth">{children}</table>
  </div>
);
